import { FeeModalities } from '@tokeet/cost-resolver'

export const FeeModalityLabels: { [key: string]: string } = {
  [FeeModalities.PerPerson]: `Per Person`,
  [FeeModalities.PerNight]: `Per Night`,
  [FeeModalities.PerPersonPerNight]: `Per Person/Per Night (PP/PN)`,
  [FeeModalities.PerStay]: `Per Stay`,
}

export interface BookingEngineAuditDay {
  date: string // YYYY-MM-DD
  rate: number
  booking_occupancy?: {
    occupancy: number
    additional_bedroom_fee: number
    bedroom_threshold: number
    bedroom_adjustment?: number
  }
  restrictions?: {
    checkout_blocked?: 1
    checkin_blocked?: 1
    maximumstay_arrival?: number // in days,
    minimumstay_arrival?: number
    max_advance_res: string // "6D0H",
    min_advance_res: string // "2D0H",
  }
}
